import { escape } from "lodash";

// REGEXP PATTERN for link parsing inside string
const linkPattern =
    /((https?:\/\/[a-z0-9]+)|(www\.[a-z0-9]+\.\S)|(ftp:\/\/))[a-z0-9//;:\?\._~&#\-=+%\)\(]*[a-z0-9)(/_~&#\-=+%]/gi;

export const linkifyTextString = (string: string, target: string) => {
    string = escape(string); // string tags cleanup
    target = target ? ` target="${target}"` : "";
    string = string.replace(linkPattern, (match, p1) => {
        let url = match;
        if (p1.startsWith("www")) {
            url = "http://" + url;
        }
        return `<a js-prevent-navigation href='${url}'${target}>${match}</a>`;
    });
    return string;
};
